export default {
    it: {
        "useful-documents": "Documenti utili:"
    },
    en: {
        "useful-documents": "Useful documents:"
    }
}